import { Avatar, Box, Typography } from "@mui/material";
import { useState } from "react";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { imgUrl } from "src/Helpers/utils/constants";
const CommonPdfAndImageView = ({
	file,
	fileName,
	showAvater,
}: {
	file: string | null;
	fileName?: string;
	showAvater?: boolean;
}) => {
	const type = file?.split(".")?.[1];
	const [open, setOpen] = useState<boolean>(false);

	return (
		<Box>
			{showAvater ? (
				<Avatar
					src={`${imgUrl}/${file}`}
					onClick={() => {
						console.log("Clicked!");
						setOpen(true);
					}}
					sx={{ cursor: "pointer" }}
				/>
			) : (
				<Typography
					variant='body1'
					fontWeight='bold'
					display='inline'
					sx={{
						pr: 1,
						cursor: "pointer",
						color: "#0000ef",
						zIndex: 100,
					}}
					gutterBottom
					onClick={() => {
						console.log("Clicked!");
						setOpen(true);
					}}
				>
					{fileName || "View File"}
				</Typography>
			)}

			{/* <img alt='' height={"100px"} width={"100px"} /> */}

			<ModalsWrapper
				modalData={{ title: "View document" }}
				setShowModal={setOpen}
				showModal={open}
			>
				<div style={{ padding: "0px 10px" }}>
					{file && type ? (
						<>
							{type === "pdf" ? (
								<div style={{ width: "800px" }}></div>
							) : (
								<>
									<img
										src={`${imgUrl}/${file}`}
										alt=''
										height={"100%"}
										width={"100%"}
									/>
									<Box>
										<a
											href={`${imgUrl}/${file}`}
											target='_blank'
											rel='noopener noreferrer'
										>
											Download
										</a>
									</Box>
								</>
							)}
						</>
					) : (
						<Typography
							py={2}
							px={2}
							textAlign={"center"}
							variant='h5'
						>
							No file found
						</Typography>
					)}
				</div>{" "}
			</ModalsWrapper>
		</Box>
	);
};

export default CommonPdfAndImageView;
